module.exports = __webpack_public_path__ + "img/round-rectangle.6e6408f1.svg";